import { SvgIcon, SvgIconProps } from '@mui/material';


/**
 * Component displays call play svg icon 
 * @param props -SvgIconProps
 * @returns call play svg icon
 * @example - <CcfAudioPlayIcon />
 */
export function CcfAudioPlayIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Play" transform="translate(-12.383 6.777)">
        <path id="Path_13266" data-name="Path 13266" d="M120-107.17v-6.039c0-1.042.74-1.428,1.638-.86l13.686,8.694a1.144,1.144,0,0,1,0,2.088L121.638-94.6c-.9.576-1.638.2-1.638-.852V-107.17Z" transform="translate(-107.617 107.554)" />
      </g>
    </SvgIcon>
  );
}
export default CcfAudioPlayIcon;
